import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { PutProjectFailure, PutProjectRequest, PutProjectSuccess } from './actions';
import { PutProjectService } from './service';
import { ProjectUpdateProject } from '@store/flow-data/project';

@Injectable()
export class PutProjectEffects {
  private readonly actions$ = inject(Actions);
  private readonly putProjectService = inject(PutProjectService);

  putProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PutProjectRequest),
      switchMap(({ body, parameters }) =>
        this.putProjectService.putProject(body, parameters).pipe(
          switchMap(data => [ProjectUpdateProject({ data }), PutProjectSuccess({ data })]),
          catchError(error => of(PutProjectFailure({ error })))
        )
      )
    )
  );

}
